import styled from 'styled-components';
import { AntSelect } from './select.style';

const AntCascader = (component) => styled(AntSelect(component))`
  &.ant-cascader {
    width: unset;
  }
`;

export { AntCascader };
